import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ResponseChangeModel } from 'src/app/incident/incident.component';


@Component({
  selector: 'app-inputType-chk',
  templateUrl: './inputType-chk.component.html',
  styleUrls: ['./inputType-chk.component.scss']
,  standalone: false
})
export class InputTypeChkComponent implements OnInit, OnChanges {

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;  
  @Input() isMatrix?: boolean=false;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Input() showName?: boolean=true; 
  @Input() IsReadOnly?:boolean=false;
  @Input() IsConsentScreen?:boolean=false;
  optionArray: CheckBoxOptions[] = [];
  options: string = "";
  isConditionIsTrue: boolean;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  @Output() conditionalChange: EventEmitter<ResponseChangeModel> = new EventEmitter<ResponseChangeModel>();

  constructor(private cdr: ChangeDetectorRef, private zone: NgZone) {}
  
  ngOnChanges(changes: SimpleChanges) {    
     if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {
        const arrResp = this.question.responseText.split("||");
        this.question.options.forEach(option => {
          option['selected'] = arrResp.indexOf(option.value) !== -1;
        });
      } else {      
        if (this.question.options) {
          this.question.options.forEach(option => option['selected'] = false);
        }      
      }
      
      this.CheckValidations();
      this.childQuestion.emit(this.question);
      this.cdr.markForCheck();      
    }
  }
  
 validateRequired() {
  this.errormgvisible = false;
  this.validationerrormessage = [];

  if (
    this.question.isQuestionRequired === "Y" &&
    (!this.question.responseText || this.question.responseText.trim().length === 0)
  ) {
    this.errormgvisible = true;
    this.question["IsValid"] = false;
    this.validationerrormessage.push("Input is mandatory");
    this.childQuestion.emit(this.question);
  }
}

ngDoCheck() {
  if (this.question.errorMessage) {
  this.validateRequired();
}
}

  ngOnInit() {
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;
  //  this.question.questionIndex=this.questionIndex;
    if (this.question.isQuestionRequired == "Y") {
      this.isConditionIsTrue = true;
    }
    else {
      this.isConditionIsTrue = false;
    }
    //Bind saved user response on load
    if(this.question.responseText && this.question.responseText.length>0)
    {
      //this.IsReadOnly=true;
      let arrResp= this.question.responseText.split("||");
      let optSelected=[];
      this.question.options.forEach(function(x,y){
        if(arrResp.indexOf(x.value)!=-1)
        {
          optSelected.push(y);
        }       
      });
       optSelected.forEach(x=> {
        this.question.options[x]["selected"]=true
      })

        if (this.question.isQuestionRequired == "Y" && optSelected.length>0) {
          this.question["IsValid"]=true;
        }
    }
  }

  // onSelect_OLD(event, question,index) {
  //   this.optionArray = [];
  //   let checkboxoptions = new CheckBoxOptions();
  //   if (event.checked === true) {
  //     checkboxoptions.value = this.question.options[index].value;
  //     checkboxoptions.index = index;
  //     question.options[index].selected = true;
  //     this.optionArray.push(checkboxoptions);
  //   }
  //   else if (event.checked === false) {
  //     this.optionArray.forEach((obj, childindex) => {
  //       if (obj.index == index) {
  //         this.optionArray.splice(childindex, 1);
  //       }
  //     });
  //     question.options[index].selected = false;
  //   }

  //   question.options.forEach((obj, index) => {
  //     if (obj["selected"]) {
  //       let checkboxoption = new CheckBoxOptions();
  //       checkboxoption.value = obj.value;
  //       checkboxoption.index = index;
  //       this.optionArray.push(checkboxoption);
  //     }
  //   });

  //   this.options = "";
  //   this.optionArray.forEach((obj, childindex) => {
  //       this.options += obj.value + "||";
  //     //length -2 is for removing || at the end of the options string
  //   });
  //   this.options = this.options.substring(0, this.options.length - 2);
  //   let resp = new Set(this.options.split("||"))
  //   this.options = Array.from(resp).join("||");
  //   this.question["responseText"] = this.options;
  //   if (this.question.isQuestionRequired == "Y") {
  //     if (this.options == null || this.options == "") {
  //       this.question["IsValid"] = false;
  //     }
  //     else {
  //       this.question["IsValid"] = true;
  //     }
  //   }
  //   else {
  //     this.question["IsValid"] = true;
  //   }
  //   //Emit the question object to parent component
  //   this.childQuestion.emit(this.question);
  //   this.inputChange.emit(this.question)
  // }


  onCheckBoxClick(event: any, value: string, index: number) {
    // Prevent default checkbox behavior to wait for parent's response
    event.preventDefault();
    event.stopPropagation();

    //const isChecked = !this.question.options[index]['selected'];
    const isChecked = (event.target as MatCheckboxChange).checked;

    
    // Create a copy of the question and its options to determine the pending state
    const updatedQuestion = { ...this.question, options: this.question.options.map(o => ({ ...o })) };

    // Update the selected state of the clicked option based on the event
    updatedQuestion.options[index]['selected'] = isChecked;

    // Generate the new responseText based on all selected options
    const pendingResponseText = updatedQuestion.options
      .filter(option => option['selected'])
      .map(option => option.value)
      .join('||');
    updatedQuestion.responseText = pendingResponseText;

    // First emit the check event and wait for parent's decision from pop up if any conditonal questions are there
    this.conditionalChange.emit({
      question: updatedQuestion,
      oldResponse: this.question.responseText,
      newResponse: pendingResponseText,
      proceed: (shouldProceed: boolean) => {
        this.zone.run(() => {
          if (shouldProceed) {
            // Update the component's question object with the new state
            /** Important Note : Need to use map for options as its mutable 
             * and only that works direct assignment of options is changing 
             * the original state of object **/
            const setOptions = this.question.options.map((opt, i) => {
              if (i === index) {
                return { ...opt, selected: isChecked };
              }
              return opt;
            });
            this.question = { ...this.question, options: setOptions };
            this.question.responseText = pendingResponseText;
            this.inputChange.emit(true); // Emit input change event only whn value changes
          }
          else {
            // If the parent component cancels the change, revert the model state.
            // The UI was not updating because the object reference did not change.
            // By creating a new options array, we trigger change detection.
            const revertedOptions = this.question.options.map((opt, i) => {
              if (i === index) {
                return { ...opt, selected: !isChecked };
              }
              return opt;
            });
            this.question = { ...this.question, options: revertedOptions };
            
            // Also revert the responseText to its previous state
            this.question.responseText = this.question.options
              .filter(option => option['selected'])
              .map(option => option.value)
              .join('||');
          }
          this.CheckValidations();
          // Force the view to update in both cases
          this.cdr.markForCheck();
          this.childQuestion.emit(this.question);
        });
      }
    });    
  }

  CheckValidations() {
    const isRequired = this.question.isQuestionRequired === "Y";
    const hasResponse = this.question.responseText && this.question.responseText.trim().length > 0;

    if (isRequired && !hasResponse) {
      this.question["IsValid"] = false;
      this.errormgvisible = true;
      this.validationerrormessage = [`Input is mandatory`];
    } else {
      this.question["IsValid"] = true;
      this.errormgvisible = false;
      this.validationerrormessage = [];
    }
  }

}
export class CheckBoxOptions {
  value: string;
  index: number;
  isSelected: boolean;
}
